"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FundNetProspectRequest = void 0;
var FundNetProspectRequest = /** @class */ (function () {
    function FundNetProspectRequest() {
    }
    return FundNetProspectRequest;
}());
exports.FundNetProspectRequest = FundNetProspectRequest;
;
//# sourceMappingURL=fundNetProspect.request.js.map